'use strict';

require('../CompanyService.js');

function CompanySettingTaskTypesCtrl(
  $scope,
  taskTypes,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyService,
  growl
) {
  // Task statuses
  $scope.taskTypes = taskTypes;
  $scope.addTaskType = function() {
    $scope.taskTypes.push({
      name: '',
      color: 4279856278,
      type: 'CUSTOME'
    });

    $scope.lastItemTaskTypes = $scope.taskTypes.length - 1;
  };

  $scope.saveTaskTypes = function() {
    angular.forEach($scope.taskTypes, function(taskType){
      if(!taskType.id){
        taskType.code = taskType.name;
      }
    });
    CompanyService.updateTaskTypes({companyId: $stateParams.companyId}, $scope.taskTypes, function() {
      $state.reload();
      growl.addSuccessMessage(translations['settings.save-task-types-success']);
    });
  };
}

CompanySettingTaskTypesCtrl.resolve = {
  taskTypes: ['$stateParams', 'CompanyService', function($stateParams, CompanyService) {
    return CompanyService.queryTaskTypes({companyId: $stateParams.companyId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
     'settings.save-task-types-success'
    ]);
  }]
};
module.exports = CompanySettingTaskTypesCtrl;

angular.module('dokiv')
  .controller('CompanySettingTaskTypesCtrl', [
  '$scope',
  'taskTypes',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyService',
  'growl',
  CompanySettingTaskTypesCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingTaskTypesCtrl.js
// module id = 415
// module chunks = 0